import { render } from "./Navbar.vue?vue&type=template&id=61945ea7&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=61945ea7&lang=scss"
import "./Navbar.vue?vue&type=style&index=1&id=61945ea7&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61945ea7"]])

export default __exports__